import { authRoles } from "../../../auth/authRoles";
import Konten from "./Konten/Konten";
import EditMilestone from "./Milestone/EditMilestone";
import Milestone from "./Milestone/Milestone";
import TambahMilestone from "./Milestone/TambahMilestone";
import Values from "./Values/Values";
import Vismis from "./Vismis/Vismis";

const sejarahPerusahaanRoutes = [
  {
    path: "/milestone/edit/:id",
    exact: true,
    component: EditMilestone,
    auth: authRoles.all,
  },
  {
    path: "/milestone/tambah",
    exact: true,
    component: TambahMilestone,
    auth: authRoles.all,
  },
  {
    path: "/milestone",
    exact: true,
    component: Milestone,
    auth: authRoles.all,
  },
  {
    path: "/sejarah_perusahaan",
    exact: true,
    component: Konten,
    auth: authRoles.all,
  },
  {
    path: "/visi_misi",
    exact: true,
    component: Vismis,
    auth: authRoles.all,
  },
  {
    path: "/nilai_perusahaan",
    exact: true,
    component: Values,
    auth: authRoles.all,
  },
];

export default sejarahPerusahaanRoutes;
